import React from 'react';
import { FaLinkedin, FaBlog, FaArrowUp } from 'react-icons/fa';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer Content */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Profile Section */}
          <div className="space-y-4">
            <h3 className="text-2xl font-bold">Shalender Kumar</h3>
            <p className="text-gray-300 leading-relaxed">
              Senior PHP Web Developer with 10+ years of experience creating 
              innovative web solutions across multiple industries.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.linkedin.com/in/shalender8928/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-blue-600 hover:bg-blue-700 rounded-full flex items-center justify-center transition-colors duration-300"
                aria-label="LinkedIn Profile"
              >
                <FaLinkedin />
              </a>
              <a
                href="https://codinghelpsolutions.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-700 hover:bg-gray-600 rounded-full flex items-center justify-center transition-colors duration-300"
                aria-label="Technical Blog"
              >
                <FaBlog />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Quick Links</h4>
            <ul className="space-y-2">
              {[
                { name: 'About', id: 'about' },
                { name: 'Skills', id: 'skills' },
                { name: 'Experience', id: 'experience' },
                { name: 'Projects', id: 'projects' },
                { name: 'Contact', id: 'contact' }
              ].map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => document.getElementById(link.id)?.scrollIntoView({ behavior: 'smooth' })}
                    className="text-gray-300 hover:text-white transition-colors duration-300"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Contact Information</h4>
            <div className="space-y-3 text-gray-300">
              <div>
                <p className="font-medium text-white">Email:</p>
                <a
                  href="mailto:shalender8928@yahoo.com"
                  className="hover:text-blue-400 transition-colors duration-300"
                >
                  shalender8928@yahoo.com
                </a>
              </div>
              <div>
                <p className="font-medium text-white">Location:</p>
                <p>Ludhiana, Punjab, India</p>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-700 my-8"></div>

        {/* Skills Summary */}
        {/*<div className="text-center mb-8">
          <h4 className="text-lg font-semibold mb-4">Core Technologies</h4>
          <div className="flex flex-wrap justify-center gap-3">
            {[
              'PHP', 'Laravel', 'Livewire', 'WordPress', 'CodeIgniter', 'JavaScript',
              'MySQL', 'jQuery', 'AJAX', 'HTML', 'CSS', 'Git'
            ].map((skill) => (
              <span
                key={skill}
                className="bg-gray-800 text-gray-300 px-3 py-1 rounded-full text-sm"
              >
                {skill}
              </span>
            ))}
          </div>
        </div>*/}

          <div className="text-center mb-12">
            <h4 className="text-xl font-bold mb-6">Core Technologies</h4>
            <div className="flex flex-wrap justify-center gap-4">
              {/* Backend */}
              <div className="flex gap-2 flex-wrap justify-center">
                <span className="bg-blue-600 text-white px-4 py-2 rounded-full text-sm hover:bg-blue-700 transition">PHP</span>
                <span className="bg-blue-600 text-white px-4 py-2 rounded-full text-sm hover:bg-blue-700 transition">Laravel</span>
                <span className="bg-blue-600 text-white px-4 py-2 rounded-full text-sm hover:bg-blue-700 transition">Livewire</span>
                <span className="bg-blue-600 text-white px-4 py-2 rounded-full text-sm hover:bg-blue-700 transition">CodeIgniter</span>
                <span className="bg-blue-600 text-white px-4 py-2 rounded-full text-sm hover:bg-blue-700 transition">WordPress</span>
              </div>
              {/* Frontend */}
              <div className="flex gap-2 flex-wrap justify-center">
                <span className="bg-green-600 text-white px-4 py-2 rounded-full text-sm hover:bg-green-700 transition">Vue.js</span>
                <span className="bg-green-600 text-white px-4 py-2 rounded-full text-sm hover:bg-green-700 transition">React.js</span>
                <span className="bg-green-600 text-white px-4 py-2 rounded-full text-sm hover:bg-green-700 transition">Alpine.js</span>
                <span className="bg-green-600 text-white px-4 py-2 rounded-full text-sm hover:bg-green-700 transition">JavaScript</span>
                <span className="bg-green-600 text-white px-4 py-2 rounded-full text-sm hover:bg-green-700 transition">jQuery</span>
              </div>
              {/* Database */}
              <div className="flex gap-2 flex-wrap justify-center">
                <span className="bg-yellow-600 text-white px-4 py-2 rounded-full text-sm hover:bg-yellow-700 transition">MySQL</span>
                <span className="bg-yellow-600 text-white px-4 py-2 rounded-full text-sm hover:bg-yellow-700 transition">Redis</span>
              </div>
              {/* DevOps & Tools */}
              <div className="flex gap-2 flex-wrap justify-center">
                <span className="bg-purple-600 text-white px-4 py-2 rounded-full text-sm hover:bg-purple-700 transition">DigitalOcean</span>
                <span className="bg-purple-600 text-white px-4 py-2 rounded-full text-sm hover:bg-purple-700 transition">AWS S3</span>
                <span className="bg-purple-600 text-white px-4 py-2 rounded-full text-sm hover:bg-purple-700 transition">Git</span>
                <span className="bg-purple-600 text-white px-4 py-2 rounded-full text-sm hover:bg-purple-700 transition">CI/CD</span>
                <span className="bg-purple-600 text-white px-4 py-2 rounded-full text-sm hover:bg-purple-700 transition">Queue Workers</span>
              </div>
            </div>
          </div>


        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-gray-700">
          <div className="flex items-center space-x-2 text-gray-300 mb-4 md:mb-0">
            <span>© {currentYear} Shalender Kumar.</span>
          </div>

          {/* Back to Top */}
          <button
            onClick={scrollToTop}
            className="bg-blue-600 hover:bg-blue-700 text-white p-3 rounded-full shadow-md hover:-translate-y-2 transition-all duration-300"
            aria-label="Back to top"
          >
            <FaArrowUp />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
